export interface FAQ {
  id: number;
  question: string;
  answer: string;
  category: 'general' | 'cost' | 'process' | 'emergency' | 'local';
}

export const faqs: FAQ[] = [
  {
    id: 1,
    question: 'Who provides roofing services near me in Chicago?',
    answer: 'Green World Construction and Roofing provides professional roofing, tuckpointing, siding, and exterior construction services throughout Chicago and 24+ Chicagoland suburbs. Family-owned since 1989, we serve both residential and commercial clients with free inspections and written estimates.',
    category: 'local',
  },
  {
    id: 2,
    question: 'How much do roofing services cost in Chicago?',
    answer: 'Roofing costs vary based on roof size, pitch, material type, and extent of damage or replacement needed. We provide free on-site inspections and written estimates so you receive an accurate, itemized quote before any work begins. There are no hidden fees or surprise costs.',
    category: 'cost',
  },
  {
    id: 3,
    question: 'How long does a roof replacement take?',
    answer: 'Most residential shingle roof replacements are completed in one to two days. Flat roof installations or larger commercial projects may take two to five days depending on scope and weather conditions. We provide a clear timeline in your written estimate before work starts.',
    category: 'process',
  },
  {
    id: 4,
    question: 'Do you offer free roof inspections in Chicago?',
    answer: 'Yes. Green World Construction offers free roof inspections for Chicago and all Chicagoland communities we serve. Our team conducts a complete on-site assessment of your roof, gutters, flashing, and related structures, then provides a written report with our findings and a detailed estimate.',
    category: 'general',
  },
  {
    id: 5,
    question: 'Do you handle emergency roof repairs?',
    answer: 'Yes, we respond to storm damage, active leaks, and urgent roof failures throughout Chicago and the suburbs. Call us directly at (708) 698-4072 to speak with our team. We prioritize emergency situations and dispatch crews as quickly as conditions allow.',
    category: 'emergency',
  },
  {
    id: 6,
    question: 'What types of roofs does Green World Construction install?',
    answer: 'We install and repair all major roofing systems including flat roofs (TPO, EPDM, built-up, aluminum coating), asphalt shingles, architectural shingles, metal roofing, and sheet metal systems. We also perform tuckpointing, masonry, chimney repair, siding, and sealcoating.',
    category: 'general',
  },
  {
    id: 7,
    question: 'Is Green World Construction licensed and insured in Illinois?',
    answer: 'Yes. Green World Construction and Roofing is fully licensed and insured for all roofing, masonry, and exterior construction work in Illinois. We have been operating in Chicago and the Chicagoland area since 1989 and maintain all required credentials and coverage.',
    category: 'general',
  },
  {
    id: 8,
    question: 'What areas in Chicagoland do you serve?',
    answer: 'We serve Chicago and 24+ surrounding suburbs including Evanston, Skokie, Oak Park, Park Ridge, Berwyn, Elmhurst, Northbrook, Barrington, Wheeling, Burbank, Cicero, Elmwood Park, Forest Park, Franklin Park, Norridge, and many more. Contact us to confirm coverage in your area.',
    category: 'local',
  },
];
